<template>
    <div id="ListAssistantActionComponent" class="list-assistant-action-component">
		<button @click="getAssistantActionByAssistantIdLocal" ref="btnGetAssistantActionByAssistantId" v-show="false">Buscar</button>
		<table class="table table-sm table-12 table-hover">
			<thead>
				<tr>
					<th>ID</th>
					<th>Opción</th>
					<th>Inicio del mensaje</th>
					<th>Fin del mensaje </th>
					<th class="text-right">
						<i class="fas fa-plus text-muted pointer" title="Editar"></i>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listAssistantActionsFilter" :key="index">
					<td>{{ item.id }}</td>
					<td>{{ item.option }}</td>
					<td>{{ item.message_begin }}</td>
					<td>{{ item.message_end }}</td>
					<th class="text-right">
						<router-link :to="'/assistant/' + assistantId + '/action/' + item.id">
							<i class="far fa-edit text-muted pointer" title="Editar"></i>
						</router-link>
					</th>
				</tr>
			</tbody>
		</table>
    </div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import assistantAction from '@/mixins/generals/assistantAction.js'

export default {
	mixins: [axiosAction, errors, mixin, assistantAction],
    name: 'ListAssistantActionComponent',
	props: ['assistantId'],
	computed: {
		listAssistantActionsFilter() {
			return this.listAssistantActions
		}
	},
	methods: {
		getAssistantActionByAssistantIdLocal() {
			this.getAssistantActionByAssistantId(this.assistantId)
		},
		getAssistantActionByAssistantIdResultLocal(response) {},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getAssistantActionByAssistantIdResult': this.getAssistantActionByAssistantIdResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
        },
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
